import { Pipe, PipeTransform } from '@angular/core';
import { Rotina } from '../../modelos/rotina';

@Pipe({
  name: 'filtroRotinas'
})
export class FiltroRotinasPipe implements PipeTransform {

  transform(rotinas: Rotina[], filtro?: string): any {
    if (rotinas === undefined || filtro === undefined || filtro.trim() === '') {
      return rotinas;
    }
    filtro = filtro.toLocaleLowerCase();
    return rotinas.filter(rotina => rotina.descricaoRotina.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-rotinas.pipe.ts